var map = {
	"./level1/pic10-1.png": [
		81726,
		81726
	],
	"./level1/pic11-1.png": [
		20667,
		20667
	],
	"./level1/pic12-1.png": [
		17870,
		17870
	],
	"./level1/pic14-1.png": [
		39616,
		39616
	],
	"./level1/pic15-1.png": [
		4935,
		4935
	],
	"./level1/pic16-1.png": [
		3276,
		3276
	],
	"./level1/pic17-1.png": [
		39116,
		39116
	],
	"./level1/pic18-1.png": [
		22161,
		22161
	],
	"./level1/pic2-1.png": [
		30161,
		30161
	],
	"./level1/pic20-1.png": [
		62809,
		62809
	],
	"./level1/pic21-1.png": [
		64347,
		64347
	],
	"./level1/pic22-1.png": [
		84509,
		84509
	],
	"./level1/pic23-1.png": [
		21242,
		21242
	],
	"./level1/pic24-1.png": [
		45538,
		45538
	],
	"./level1/pic26-1.png": [
		6368,
		6368
	],
	"./level1/pic27-1.png": [
		34265,
		34265
	],
	"./level1/pic28-1.png": [
		76024,
		76024
	],
	"./level1/pic29-1.png": [
		79264,
		79264
	],
	"./level1/pic3-1.png": [
		1949,
		1949
	],
	"./level1/pic30-1.png": [
		79368,
		79368
	],
	"./level1/pic32-1.png": [
		67684,
		67684
	],
	"./level1/pic33-1.png": [
		62673,
		62673
	],
	"./level1/pic34-1.png": [
		80090,
		80090
	],
	"./level1/pic35-1.png": [
		62798,
		62798
	],
	"./level1/pic36-1.png": [
		49341,
		49341
	],
	"./level1/pic38-1.png": [
		26563,
		26563
	],
	"./level1/pic39-1.png": [
		57592,
		57592
	],
	"./level1/pic4-1.png": [
		18194,
		18194
	],
	"./level1/pic40-1.png": [
		45097,
		45097
	],
	"./level1/pic41-1.png": [
		54146,
		54146
	],
	"./level1/pic42-1.png": [
		60835,
		60835
	],
	"./level1/pic44-1.png": [
		13233,
		13233
	],
	"./level1/pic45-1.png": [
		13977,
		13977
	],
	"./level1/pic46-1.png": [
		37447,
		37447
	],
	"./level1/pic47-1.png": [
		38775,
		38775
	],
	"./level1/pic48-1.png": [
		83905,
		83905
	],
	"./level1/pic5-1.png": [
		62637,
		62637
	],
	"./level1/pic6-1.png": [
		63474,
		63474
	],
	"./level1/pic8-1.png": [
		40680,
		40680
	],
	"./level1/pic9-1.png": [
		29170,
		29170
	],
	"./level2/pic10-1.png": [
		26414,
		26414
	],
	"./level2/pic11-1.png": [
		56363,
		56363
	],
	"./level2/pic12-1.png": [
		19991,
		19991
	],
	"./level2/pic14-1.png": [
		42271,
		42271
	],
	"./level2/pic15-1.png": [
		58326,
		58326
	],
	"./level2/pic16-1.png": [
		81224,
		81224
	],
	"./level2/pic17-1.png": [
		43448,
		43448
	],
	"./level2/pic18-1.png": [
		53480,
		53480
	],
	"./level2/pic2-1.png": [
		21576,
		21576
	],
	"./level2/pic20-1.png": [
		34589,
		34589
	],
	"./level2/pic21-1.png": [
		39294,
		39294
	],
	"./level2/pic22-1.png": [
		17632,
		17632
	],
	"./level2/pic23-1.png": [
		84615,
		84615
	],
	"./level2/pic24-1.png": [
		10080,
		10080
	],
	"./level2/pic26-1.png": [
		9128,
		9128
	],
	"./level2/pic27-1.png": [
		98142,
		98142
	],
	"./level2/pic28-1.png": [
		26120,
		26120
	],
	"./level2/pic29-1.png": [
		67930,
		67930
	],
	"./level2/pic3-1.png": [
		70281,
		70281
	],
	"./level2/pic30-1.png": [
		21709,
		21709
	],
	"./level2/pic32-1.png": [
		76951,
		76951
	],
	"./level2/pic33-1.png": [
		41455,
		41455
	],
	"./level2/pic34-1.png": [
		82109,
		82109
	],
	"./level2/pic35-1.png": [
		39372,
		39372
	],
	"./level2/pic36-1.png": [
		93665,
		93665
	],
	"./level2/pic38-1.png": [
		19951,
		19951
	],
	"./level2/pic39-1.png": [
		66741,
		66741
	],
	"./level2/pic4-1.png": [
		19164,
		19164
	],
	"./level2/pic40-1.png": [
		18991,
		18991
	],
	"./level2/pic41-1.png": [
		82063,
		82063
	],
	"./level2/pic42-1.png": [
		81671,
		81671
	],
	"./level2/pic44-1.png": [
		59798,
		59798
	],
	"./level2/pic45-1.png": [
		15221,
		15221
	],
	"./level2/pic46-1.png": [
		45601,
		45601
	],
	"./level2/pic47-1.png": [
		69048,
		69048
	],
	"./level2/pic48-1.png": [
		65425,
		65425
	],
	"./level2/pic5-1.png": [
		67578,
		67578
	],
	"./level2/pic6-1.png": [
		87046,
		87046
	],
	"./level2/pic8-1.png": [
		17992,
		17992
	],
	"./level2/pic9-1.png": [
		43065,
		43065
	],
	"./level3/pic10-1.png": [
		91999,
		91999
	],
	"./level3/pic11-1.png": [
		72794,
		72794
	],
	"./level3/pic12-1.png": [
		47116,
		47116
	],
	"./level3/pic14-1.png": [
		6520,
		6520
	],
	"./level3/pic15-1.png": [
		77498,
		77498
	],
	"./level3/pic16-1.png": [
		43523,
		43523
	],
	"./level3/pic17-1.png": [
		65373,
		65373
	],
	"./level3/pic18-1.png": [
		89996,
		89996
	],
	"./level3/pic2-1.png": [
		60590,
		60590
	],
	"./level3/pic20-1.png": [
		57088,
		57088
	],
	"./level3/pic21-1.png": [
		71067,
		71067
	],
	"./level3/pic22-1.png": [
		33289,
		33289
	],
	"./level3/pic23-1.png": [
		9582,
		9582
	],
	"./level3/pic24-1.png": [
		51756,
		51756
	],
	"./level3/pic3-1.png": [
		62682,
		62682
	],
	"./level3/pic4-1.png": [
		3803,
		3803
	],
	"./level3/pic5-1.png": [
		91500,
		91500
	],
	"./level3/pic6-1.png": [
		17610,
		17610
	],
	"./level3/pic8-1.png": [
		40691,
		40691
	],
	"./level3/pic9-1.png": [
		68306,
		68306
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47549;
module.exports = webpackAsyncContext;